module.exports = __webpack_public_path__ + "static/img/qrcode1.0a28b4c1.png";